export const MODAL_NAMES = {
  DeleteScenarioMemberModal: 'DeleteScenarioMemberModal',
};

export const MAX_NUMBER_OF_MEMBERS_PER_SCENARIO = 1000;
